module.exports = __webpack_public_path__ + "img/5g-logo.f3f837e7.svg";